import { Divider } from 'antd'
import styled from 'styled-components'
import { margin } from 'theme/mixins'

const NewOptionDivider = styled(Divider)`
	margin-top: ${margin('sm')};
	margin-bottom: ${margin('sm')};
`

export default { NewOptionDivider }
